export const homeLinks = [
  {
    id: 0,
    name: "Products",
    href: "#products",
  },
  {
    id: 1,
    name: "Services",
    href: "#services",
  },
  {
    id: 2,
    name: "About",
    href: "#about",
  },
  {
    id: 3,
    name: "Contact",
    href: "#contact",
  },
];

export const deviceInfoLinks = [
  {
    id: 0,
    name: "Features",
    href: "#features",
  },
  {
    id: 1,
    name: "Screenshots",
    href: "#screenshots",
  },
  {
    id: 2,
    name: "Reviews",
    href: "#reviews",
  },
  {
    id: 3,
    name: "FAQs",
    href: "#faqs",
  },
];
